import { MaritalStatus } from '../../shared/models/enums/marital-status.enum';
import { Title } from '../../shared/models/enums/title.enum';
import { BeneficiaryAddressDto } from './beneficiary-address.dto';
import { BeneficiaryIntensityDto } from './beneficiary-intensity.dto';
import { OrientationDto } from './orientationDto';
import { ReferentDto } from './referent.dto';
import { SupportDto } from './supportDto';

export class BeneficiaryDto {
  constructor(
    public id: number,
    public rsjId: number,
    public title: Title,
    public recipientNumber: string,
    public landlineNumber: string,
    public jobCenterNumber: string,
    public usualName: string,
    public surname: string,
    public firstName: string,
    public secondName: string,
    public birthDate: Date,
    public nationality: string,
    public birthPostalCode: string,
    public birthCity: string,
    public attachedOrganization: string,
    public status: string,
    public orientation: OrientationDto,
    public support: SupportDto,
    public cellPhoneNumber: string,
    public sms: boolean,
    public emailAddress: string,
    public email: boolean,
    public residentialAddress: BeneficiaryAddressDto,
    public postalAddress: BeneficiaryAddressDto,
    public addresses: BeneficiaryAddressDto[],
    public identicalPostalAddress: boolean,
    public residentialAddresses: BeneficiaryAddressDto[],
    public postalAddresses: BeneficiaryAddressDto[],
    public maritalStatus: MaritalStatus,
    public complementId: number,
    public employmentId: number,
    public beginRsaDate?: Date,
    public lastUpdateDate?: Date,
    public lastDateInterview?: Date,
    public iodasNumber?: string,
    public insertisId?: string,
    public orientedBy?: string,
    public followedBy?: string,
    public supportStatus?: boolean,
    public supportStatusTypeIds?: number[],
    public isEmployee?: boolean,
    public isJobSeeker?: boolean,
    public isIndependent?: boolean,
    public isStudent?: boolean,
    public inTraining?: boolean,
    public isOther?: boolean,
    public referents?: ReferentDto[],
    public intensities?: BeneficiaryIntensityDto[],
    public orientations?: OrientationDto[],
    public supports?: SupportDto[],
  ) {}

  public static fromJson(json: any): BeneficiaryDto {
    return new BeneficiaryDto(
      json.id,
      json.rsjId,
      json.title,
      json.recipientNumber,
      json.landlineNumber,
      json.jobCenterNumber,
      json.usualName,
      json.surname,
      json.firstName,
      json.secondName,
      json.birthDate ? new Date(json.birthDate) : undefined,
      json.nationality,
      json.birthPostalCode,
      json.birthCity,
      json.attachedOrganization,
      json.status,
      json.orientation ? OrientationDto.fromJson(json.orientation) : undefined,
      json.support ? SupportDto.fromJson(json.support) : undefined,
      json.cellPhoneNumber,
      json.sms,
      json.emailAddress,
      json.email,
      json.residentialAddress ? BeneficiaryAddressDto.fromJson(json.residentialAddress) : undefined,
      json.postalAddress ? BeneficiaryAddressDto.fromJson(json.postalAddress) : undefined,
      json.addresses ? json.addresses.map(BeneficiaryAddressDto.fromJson) : undefined,
      json.identicalPostalAddress,
      json.residentialAddresses ? json.residentialAddresses.map(BeneficiaryAddressDto.fromJson) : undefined,
      json.postalAddresses ? json.postalAddresses.map(BeneficiaryAddressDto.fromJson) : undefined,
      json.maritalStatus,
      json.complementId,
      json.employmentId,
      json.beginRsaDate ? new Date(json.beginRsaDate) : undefined,
      json.lastUpdateDate ? new Date(json.lastUpdateDate) : undefined,
      json.lastDateInterview ? new Date(json.lastDateInterview) : undefined,
      json.iodasNumber,
      json.insertisId,
      json.orientedBy,
      json.followedBy,
      json.supportStatus,
      json.supportStatusTypeIds,
      json.isEmployee,
      json.isJobSeeker,
      json.isIndependent,
      json.isStudent,
      json.inTraining,
      json.isOther,
      json.referents ? json.referents.map(ReferentDto.fromJson) : undefined,
      json.intensities ? json.intensities.map(BeneficiaryIntensityDto.fromJson) : undefined,
      json.orientations ? json.orientations.map(OrientationDto.fromJson) : undefined,
      json.supports ? json.supports.map(SupportDto.fromJson) : undefined,
    );
  }
}
